module.exports = __webpack_public_path__ + "img/cdn.d200c499.svg";